import React from "react";

import styles from "./Headline.module.css";

export type HeadlineProps = {
  title: string | React.ReactNode;
  flex?: boolean;
  children?: React.ReactNode;
};

export function Headline({ title, flex, children }: HeadlineProps) {
  return (
    <header className={flex ? styles.header : ""}>
      <h4>{title}</h4>
      {children}
    </header>
  );
}
